import { useSafetyPolicies } from "@/api/safety-policies";
import { useTikTokAdsConnectionStatus } from "@/api/tiktok-ads";
import { PolicyListCard } from "@/components/safety-config/PolicyListCard";
import { QuarantineSection } from "./QuarantineSection";

export const TabPolicies = ({ onOpenPolicy }: { onOpenPolicy: (policyId: string) => void }) => {
  const { data: policies } = useSafetyPolicies();
  const { data: adsStatus } = useTikTokAdsConnectionStatus();

  const rows = (policies ?? []).map((policy) => ({
    id: policy.id,
    type: policy.type,
    risksUsing: policy.risksUsing,
    fired30d: policy.fired30d,
    fallbackName: policy.sequenceName,
    gmvMaxOnly: policy.gmvMaxOnly,
  }));

  return (
    <div className="flex flex-col gap-8">
      <QuarantineSection />
      <PolicyListCard rows={rows} onOpen={onOpenPolicy} adsBlocked={!adsStatus?.connected} />
    </div>
  );
};
